var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9 22.2c0-1.2.8-2 1.9-2 1.2 0 1.9.9 1.9 2 0 1.2-.8 2-1.9 2-1.1.1-1.9-.8-1.9-2zm.8-4.7-.4-15.8h3.2L16 17.5h-2.3z"
  })));
};
export default SvgWarning;